import { render, staticRenderFns } from "./TeacherCard.vue?vue&type=template&id=2d5ebfda&scoped=true&"
import script from "./TeacherCard.vue?vue&type=script&lang=ts&"
export * from "./TeacherCard.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherCard.vue?vue&type=style&index=0&id=2d5ebfda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5ebfda",
  null
  
)

export default component.exports